import HomeView from "@/pages/HomeView/i18n";
import BikeAddress from "@/pages/BikeAddress/i18n";
import Client from "@/pages/Client/i18n";
import ClientCPF from "@/pages/ClientCPF/i18n";
import Error from "@/pages/Error/i18n";
import End from "@/pages/End/i18n";
import Tutorial from "@/pages/Tutorial/i18n";
import BikePhoto from "@/pages/BikePhoto/i18n";
import BikeVideo from "@/pages/BikeVideo/i18n";
import Selfie from "@/pages/Selfie/i18n";
import BikePossession from "@/pages/BikePossession/i18n";
import BikeReceipt from "@/pages/BikeReceipt/i18n";
import BikeSerialNumber from "@/pages/BikeSerialNumber/i18n";
import Checklist from "@/pages/Checklist/i18n";
import ModelList from "@/pages/ModelList/i18n";
import PlanSelection from "@/pages/PlanSelection/i18n";
import PlanDetails from "@/pages/PlanDetails/i18n";
import ResumeInsurance from "@/pages/ResumeInsurance/i18n";
import TermsOfService from "@/pages/TermsOfService/i18n";
import EmailVerification from "@/pages/EmailVerification/i18n";
import FreePlan from "@/pages/FreePlan/i18n";
import FreePlanSelection from "@/pages/FreePlanSelection/i18n";
import HelpCentral from "@/pages/HelpCentral/i18n";
import JourneysInProgress from "@/pages/JourneysInProgress/i18n";
import Payment from "@/pages/Payment/i18n";
import type { Internationalization } from "../i18n";
import SelectBrand from "@/pages/SelectBrand/i18n";
import ReadTag from "@/pages/ReadTag/i18n";
import OwnershipWarning from "@/pages/OwnershipWarning/i18n";
import PendingPricing from "@/pages/PendingPricing/i18n";
import BikeOrScooter from "@/pages/BikeOrScooter/i18n";
import PaymentMethod from "@/pages/PaymentMethod/i18n";
import PixPayment from "@/pages/PixPayment/i18n";
import PrivacyPolicy from "@/pages/PrivacyPolicy/i18n";
import DesktopWarning from "@/pages/DesktopWarning/i18n";
import RenewalBikeConfirmation from "@/pages/RenewalBikeConfirmation/i18n";

export const pages: Internationalization = {
  pt: {
    homeView: HomeView.pt,
    bikeAddress: BikeAddress.pt,
    client: Client.pt,
    clientCPF: ClientCPF.pt,
    error: Error.pt,
    end: End.pt,
    tutorial: Tutorial.pt,
    bikePhoto: BikePhoto.pt,
    bikeVideo: BikeVideo.pt,
    selfie: Selfie.pt,
    bikePossession: BikePossession.pt,
    bikeOrScooter: BikeOrScooter.pt,
    bikeReceipt: BikeReceipt.pt,
    bikeSerialNumber: BikeSerialNumber.pt,
    checklist: Checklist.pt,
    modelList: ModelList.pt,
    selectBrand: SelectBrand.pt,
    readTag: ReadTag.pt,
    planSelection: PlanSelection.pt,
    planDetails: PlanDetails.pt,
    resumeInsurance: ResumeInsurance.pt,
    termsOfService: TermsOfService.pt,
    emailVerification: EmailVerification.pt,
    freePlan: FreePlan.pt,
    freePlanSelection: FreePlanSelection.pt,
    helpCentral: HelpCentral.pt,
    journeysInProgress: JourneysInProgress.pt,
    payment: Payment.pt,
    ownershipWarning: OwnershipWarning.pt,
    pendingPricing: PendingPricing.pt,
    paymentMethod: PaymentMethod.pt,
    pixPayment: PixPayment.pt,
    privacyPolicy: PrivacyPolicy.pt,
    desktopWarning: DesktopWarning.pt,
    renewalBikeConfirmation: RenewalBikeConfirmation.pt,
  },
  en: {
    homeView: HomeView.en,
    bikeAddress: BikeAddress.en,
    client: Client.en,
    clientCPF: ClientCPF.en,
    error: Error.en,
    end: End.en,
    tutorial: Tutorial.en,
    bikePhoto: BikePhoto.en,
    bikeVideo: BikeVideo.en,
    selfie: Selfie.en,
    bikePossession: BikePossession.en,
    bikeOrScooter: BikeOrScooter.en,
    bikeReceipt: BikeReceipt.en,
    bikeSerialNumber: BikeSerialNumber.en,
    checklist: Checklist.en,
    modelList: ModelList.en,
    selectBrand: SelectBrand.en,
    readTag: ReadTag.en,
    planSelection: PlanSelection.en,
    planDetails: PlanDetails.en,
    resumeInsurance: ResumeInsurance.en,
    termsOfService: TermsOfService.en,
    emailVerification: EmailVerification.en,
    freePlan: FreePlan.en,
    freePlanSelection: FreePlanSelection.en,
    helpCentral: HelpCentral.en,
    journeysInProgress: JourneysInProgress.en,
    payment: Payment.en,
    ownershipWarning: OwnershipWarning.en,
    pendingPricing: PendingPricing.en,
    paymentMethod: PaymentMethod.en,
    pixPayment: PixPayment.en,
    privacyPolicy: PrivacyPolicy.en,
    desktopWarning: DesktopWarning.en,
    renewalBikeConfirmation: RenewalBikeConfirmation.en,
  },
};
